import { api } from '../api'
import { useLaden } from '../hooks'
import Meldung from './Meldung'

/** Der Zweitblick vor der Freigabe: sind die Zahlen plausibel? Regeln, keine KI - sperrt nichts,
 *  steht neben dem Knopf. Lädt sich selbst für einen Importlauf. */
export default function Zweitblick({ laufId, aktiv }: { laufId: number; aktiv: boolean }) {
  const { daten: liste, laedt, fehler } = useLaden(() => api.zweitblick(laufId), [laufId], { wenn: aktiv })

  if (!aktiv) return null
  if (fehler) return <p className="hinweis">Zweitblick nicht möglich: {fehler}</p>
  if (laedt || liste === null) return <p className="hinweis">Zweitblick läuft…</p>
  if (liste.length === 0) return <p className="hinweis">Zweitblick: nichts Auffälliges - die Zahlen passen zu Mittel, Bestand und Bestellungen.</p>
  const warnungen = liste.filter((a) => a.schwere === 'warnung').length
  return (
    <Meldung art={warnungen > 0 ? 'warnung' : 'hinweis'} titel={`Zweitblick: ${liste.length} Auffälligkeit${liste.length === 1 ? '' : 'en'}`}>
      <ul>
        {liste.map((a, i) => (
          <li key={i}>
            {a.artikelnummer && <b>{a.artikelnummer} </b>}
            {a.text}
          </li>
        ))}
      </ul>
      <div className="hinweis" style={{ marginTop: 4 }}>Nur Hinweise - die Freigabe bleibt möglich.</div>
    </Meldung>
  )
}
